<div class="card card-flush">
	<div class="card-header mt-6">
		<div class="card-title">
			<div class="d-flex align-items-center position-relative my-1 me-5">
				<i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
					<span class="path1"></span>
					<span class="path2"></span>
				</i>
				<input type="text" data-table-filter="search" class="form-control form-control-sm w-250px ps-13" placeholder="Search Permissions" />
			</div>
		</div>
		<div class="card-toolbar">
			<button type="button" class="btn btn-sm btn-dark" data-bs-toggle="modal" data-bs-target="#kt_modal_add_permission">
				<i class="ki-duotone ki-plus-square fs-3">
					<span class="path1"></span>
					<span class="path2"></span>
					<span class="path3"></span>
				</i>Add Permission</button>
		</div>
	</div>
	<div class="card-body pt-0" *ngIf="data">
		<table class="table align-middle table-bordered fs-6 rounded-3 overflow-hidden" id="kt_table_permissions">
			<thead>
				<tr class="text-start text-muted fw-bold fs-7 text-uppercase bg-primary-subtle">
					<th class="min-w-125px">Name</th>
					<th class="min-w-250px">Slug</th>
					<th class="min-w-125px">Created Date</th>
					<th class="text-end min-w-100px">Actions</th>
				</tr>
			</thead>
			<tbody class="fw-semibold text-gray-600">
				<tr *ngFor="let item of data">
					<td>{{item.name}}</td>
					<td>
						{{item.slug}}
					</td>
					<td>{{item.created_at}}</td>
					<td class="text-end">
						<button class="btn btn-icon btn-active-light-primary w-30px h-30px me-3" data-bs-toggle="modal" data-bs-target="#kt_modal_update_permission">
							<i class="ki-duotone ki-setting-3 fs-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
								<span class="path4"></span>
								<span class="path5"></span>
							</i>
						</button>
						<button class="btn btn-icon btn-active-light-primary w-30px h-30px" data-table-filter="delete_row">
							<i class="ki-duotone ki-trash fs-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
								<span class="path4"></span>
								<span class="path5"></span>
							</i>
						</button>
					</td>
				</tr>
				<!-- <tr>
					<td>User Management</td>
					<td>
						<a [routerLink]="['/common','admin-users','user-detail']" class="badge badge-light-primary fs-7 m-1">Administrator</a>
					</td>
					<td>22 Sep 2024, 11:30 am</td>
					<td class="text-end">
						<button class="btn btn-icon btn-active-light-primary w-30px h-30px me-3" data-bs-toggle="modal" data-bs-target="#kt_modal_update_permission">
							<i class="ki-duotone ki-setting-3 fs-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
								<span class="path4"></span>
								<span class="path5"></span>
							</i>
						</button>
						<button class="btn btn-icon btn-active-light-primary w-30px h-30px" data-table-filter="delete_row">
							<i class="ki-duotone ki-trash fs-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
								<span class="path4"></span>
								<span class="path5"></span>
							</i>
						</button>
					</td>
				</tr>
				<tr>
					<td>Content Management</td>
					<td>
						<a [routerLink]="['/common','admin-users','user-detail']" class="badge badge-light-primary fs-7 m-1">Administrator</a>
						<a [routerLink]="['/common','admin-users','user-detail']" class="badge badge-light-danger fs-7 m-1">Developer</a>
						<a [routerLink]="['/common','admin-users','user-detail']" class="badge badge-light-success fs-7 m-1">Analyst</a>
						<a [routerLink]="['/common','admin-users','user-detail']" class="badge badge-light-info fs-7 m-1">Support</a>
						<a [routerLink]="['/common','admin-users','user-detail']" class="badge badge-light-warning fs-7 m-1">Trial</a>
					</td>
					<td>21 Feb 2024, 11:05 am</td>
					<td class="text-end">
						<button class="btn btn-icon btn-active-light-primary w-30px h-30px me-3" data-bs-toggle="modal" data-bs-target="#kt_modal_update_permission">
							<i class="ki-duotone ki-setting-3 fs-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
								<span class="path4"></span>
								<span class="path5"></span>
							</i>
						</button>
						<button class="btn btn-icon btn-active-light-primary w-30px h-30px" data-table-filter="delete_row">
							<i class="ki-duotone ki-trash fs-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
								<span class="path4"></span>
								<span class="path5"></span>
							</i>
						</button>
					</td>
				</tr>
				<tr>
					<td>Financial Management</td>
					<td>
						<a [routerLink]="['/common','admin-users','user-detail']" class="badge badge-light-primary fs-7 m-1">Administrator</a>
						<a [routerLink]="['/common','admin-users','user-detail']" class="badge badge-light-success fs-7 m-1">Analyst</a>
					</td>
					<td>19 Aug 2024, 8:43 pm</td>
					<td class="text-end">
						<button class="btn btn-icon btn-active-light-primary w-30px h-30px me-3" data-bs-toggle="modal" data-bs-target="#kt_modal_update_permission">
							<i class="ki-duotone ki-setting-3 fs-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
								<span class="path4"></span>
								<span class="path5"></span>
							</i>
						</button>
						<button class="btn btn-icon btn-active-light-primary w-30px h-30px" data-table-filter="delete_row">
							<i class="ki-duotone ki-trash fs-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
								<span class="path4"></span>
								<span class="path5"></span>
							</i>
						</button>
					</td>
				</tr>
				<tr>
					<td>Reporting</td>
					<td>
						<a [routerLink]="['/common','admin-users','user-detail']" class="badge badge-light-primary fs-7 m-1">Administrator</a>
						<a [routerLink]="['/common','admin-users','user-detail']" class="badge badge-light-success fs-7 m-1">Analyst</a>
					</td>
					<td>20 Jun 2024, 5:30 pm</td>
					<td class="text-end">
						<button class="btn btn-icon btn-active-light-primary w-30px h-30px me-3" data-bs-toggle="modal" data-bs-target="#kt_modal_update_permission">
							<i class="ki-duotone ki-setting-3 fs-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
								<span class="path4"></span>
								<span class="path5"></span>
							</i>
						</button>
						<button class="btn btn-icon btn-active-light-primary w-30px h-30px" data-table-filter="delete_row">
							<i class="ki-duotone ki-trash fs-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
								<span class="path4"></span>
								<span class="path5"></span>
							</i>
						</button>
					</td>
				</tr>
				<tr>
					<td>Payroll</td>
					<td>
						<a [routerLink]="['/common','admin-users','user-detail']" class="badge badge-light-primary fs-7 m-1">Administrator</a>
						<a [routerLink]="['/common','admin-users','user-detail']" class="badge badge-light-success fs-7 m-1">Analyst</a>
					</td>
					<td>19 Aug 2024, 5:20 pm</td>
					<td class="text-end">
						<button class="btn btn-icon btn-active-light-primary w-30px h-30px me-3" data-bs-toggle="modal" data-bs-target="#kt_modal_update_permission">
							<i class="ki-duotone ki-setting-3 fs-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
								<span class="path4"></span>
								<span class="path5"></span>
							</i>
						</button>
						<button class="btn btn-icon btn-active-light-primary w-30px h-30px" data-table-filter="delete_row">
							<i class="ki-duotone ki-trash fs-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
								<span class="path4"></span>
								<span class="path5"></span>
							</i>
						</button>
					</td>
				</tr>
				<tr>
					<td>Disputes Management</td>
					<td>
						<a [routerLink]="['/common','admin-users','user-detail']" class="badge badge-light-primary fs-7 m-1">Administrator</a>
						<a [routerLink]="['/common','admin-users','user-detail']" class="badge badge-light-danger fs-7 m-1">Developer</a>
						<a [routerLink]="['/common','admin-users','user-detail']" class="badge badge-light-info fs-7 m-1">Support</a>
					</td>
					<td>21 Feb 2024, 9:23 pm</td>
					<td class="text-end">
						<button class="btn btn-icon btn-active-light-primary w-30px h-30px me-3" data-bs-toggle="modal" data-bs-target="#kt_modal_update_permission">
							<i class="ki-duotone ki-setting-3 fs-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
								<span class="path4"></span>
								<span class="path5"></span>
							</i>
						</button>
						<button class="btn btn-icon btn-active-light-primary w-30px h-30px" data-table-filter="delete_row">
							<i class="ki-duotone ki-trash fs-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
								<span class="path4"></span>
								<span class="path5"></span>
							</i>
						</button>
					</td>
				</tr>
				<tr>
					<td>API Controls</td>
					<td>
						<a [routerLink]="['/common','admin-users','user-detail']" class="badge badge-light-primary fs-7 m-1">Administrator</a>
						<a [routerLink]="['/common','admin-users','user-detail']" class="badge badge-light-danger fs-7 m-1">Developer</a>
					</td>
					<td>19 Aug 2024, 11:05 am</td>
					<td class="text-end">
						<button class="btn btn-icon btn-active-light-primary w-30px h-30px me-3" data-bs-toggle="modal" data-bs-target="#kt_modal_update_permission">
							<i class="ki-duotone ki-setting-3 fs-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
								<span class="path4"></span>
								<span class="path5"></span>
							</i>
						</button>
						<button class="btn btn-icon btn-active-light-primary w-30px h-30px" data-table-filter="delete_row">
							<i class="ki-duotone ki-trash fs-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
								<span class="path4"></span>
								<span class="path5"></span>
							</i>
						</button>
					</td>
				</tr>
				<tr>
					<td>Database Management</td>
					<td>
						<a [routerLink]="['/common','admin-users','user-detail']" class="badge badge-light-primary fs-7 m-1">Administrator</a>
						<a [routerLink]="['/common','admin-users','user-detail']" class="badge badge-light-danger fs-7 m-1">Developer</a>
					</td>
					<td>21 Feb 2024, 2:40 pm</td>
					<td class="text-end">
						<button class="btn btn-icon btn-active-light-primary w-30px h-30px me-3" data-bs-toggle="modal" data-bs-target="#kt_modal_update_permission">
							<i class="ki-duotone ki-setting-3 fs-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
								<span class="path4"></span>
								<span class="path5"></span>
							</i>
						</button>
						<button class="btn btn-icon btn-active-light-primary w-30px h-30px" data-table-filter="delete_row">
							<i class="ki-duotone ki-trash fs-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
								<span class="path4"></span>
								<span class="path5"></span>
							</i>
						</button>
					</td>
				</tr>
				<tr>
					<td>Repository Management</td>
					<td>
						<a [routerLink]="['/common','admin-users','user-detail']" class="badge badge-light-primary fs-7 m-1">Administrator</a>
						<a [routerLink]="['/common','admin-users','user-detail']" class="badge badge-light-danger fs-7 m-1">Developer</a>
					</td>
					<td>25 Oct 2024, 10:30 am</td>
					<td class="text-end">
						<button class="btn btn-icon btn-active-light-primary w-30px h-30px me-3" data-bs-toggle="modal" data-bs-target="#kt_modal_update_permission">
							<i class="ki-duotone ki-setting-3 fs-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
								<span class="path4"></span>
								<span class="path5"></span>
							</i>
						</button>
						<button class="btn btn-icon btn-active-light-primary w-30px h-30px" data-table-filter="delete_row">
							<i class="ki-duotone ki-trash fs-3">
								<span class="path1"></span>
								<span class="path2"></span>
								<span class="path3"></span>
								<span class="path4"></span>
								<span class="path5"></span>
							</i>
						</button>
					</td>
				</tr> -->
			</tbody>
		</table>
	</div>
</div>